'use strict';

/**
 * ImageTeaserMultiple
 *
 * @author Jan Widmer <jan.widmer@namics.com>
 */
T.Module.ImageTeaserMultiple = T.createModule({

	_selectors: {
		headline: '[data-js-m-image-teaser-multiple__headline]'
	},

	start: function start(resolve) {
		// References
		this.$ctx = $(this._ctx);

		// Global Event Binding
		this._events.on('t.sync', this.sync.bind(this));

		// Lifecycle Callback
		resolve();
	},
	sync: function sync() {
		this.checkForIEIconFix();
	},


	/**
  * If we are on IE, we wrap the last word with a span to force correct linebreak with the icon
  *
  * @returns {void}
  */
	checkForIEIconFix: function checkForIEIconFix() {
		if (Modernizr.ie) {
			var $headlines = this.$ctx.find(this._selectors.headline + ' .a-link__text');

			if ($headlines.length > 0) {
				$.each($headlines, function (index, headline) {
					var stringArray = $(headline).text().split(' ');

					if (stringArray.length > 0) {
						var lastWord = stringArray[stringArray.length - 1];

						stringArray[stringArray.length - 1] = '<span class="last-word">' + lastWord + '</span>';
						$(headline).html(stringArray.join(' '));
					}
				});
			}
		}
	}
});